import React, { useState, useEffect } from 'react'
import Button from '../../../components/Button'
import styled from 'styled-components'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { formatResumeData, formatStudentData } from '../../../components/ResumeDownload/utils'
import NewResumeTemplate from 'components/ResumeDownload/NewResumeTemplate'
import { resumeBulkDownload, resumeBulkDownloadJobRoles } from '../../Placement/action'
import { singlePdf } from 'utils/downloadFile'
import ErrorMessage from 'utils/ErrorMessage'

const RESUME_DOWNLOAD_ERROR = 'Unable to download the resume. Please try again.'

const ButtonDiv = styled.div`
  margin-top: 24px;
`

const StudentResumeDetailsAction = ({ previewData, handleClick, roleID }) => {
  const [formattedData, setFormattedData] = useState(null)
  const [isDownloading, setIsDownloading] = useState(false)

  useEffect(() => {
    const formatData = async () => {
      try {
        const studentData = await formatStudentData(previewData)
        const formattedResumeData = await formatResumeData(studentData)
        setFormattedData(formattedResumeData)
      } catch (error) {
        console.error('Error formatting resume data:', error)
      }
    }

    formatData()
  }, [previewData])

  if (!formattedData) {
    return (
      <ButtonDiv>
        <Button.Primary
          height={'38px'}
          text={'Loading...'}
          width={'100%'}
          disabled={true}
        />
      </ButtonDiv>
    )
  }
  const getDefaultResume = () => {
  return previewData?.studentResumes?.find(
    resume => resume.isDefault === true && resume.fileUrl?.url
  )
}
const handleDownloadClick = async () => {
  callBulkDownloadApi()
}
const callBulkDownloadApi = async () => {
  setIsDownloading(true)
  const payload = {
     email: formattedData?.student?.email || "",
    instName: previewData?.instituteCampusName || "",
    state: formattedData?.student?.state || "",
    city: formattedData?.student?.city || "",
    user: formattedData?.student?.fullName || "",
    studentIds: [[previewData?.id]]  
  }

  try {
    const response = roleID
      ? await resumeBulkDownloadJobRoles({ ...payload, roleId: roleID })()
      : await resumeBulkDownload(payload)()

    // These actions resolve with { error, errorMessage } rather than throwing,
    // so a failure has to be caught here — otherwise singlePdf would wrap the
    // error body in a Blob and "download" a corrupt file. The common case is
    // the 422 raised when this candidate has no uploaded CV for the role.
    if (response?.error) {
      ErrorMessage(response.errorMessage || RESUME_DOWNLOAD_ERROR)
      return
    }

    await singlePdf(response, formattedData?.student?.fullName || 'Resume', previewData?.id)
  } catch (e) {
    console.error('Bulk resume download API error:', e)
    ErrorMessage(RESUME_DOWNLOAD_ERROR)
  } finally {
    setIsDownloading(false)
  }
}
const buildPayload = () => {
  const student = formattedData?.student || {}

  return {
    email: student?.email || "",
    instName: previewData?.instituteCampusName || "",
    state: student?.state || "",
    city: student?.city || "",
    user: student?.fullName || "",
    studentIds: [[previewData?.id]]  
  }
}
   const downloadURI = async (file) => {
      // Create a blob from the URL to force download
      try {
        const response = await fetch(file.url)
        if (!response.ok) {
          throw new Error('Failed to download file')
        }
        const blob = await response.blob()
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = file.name
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
        handleClick?.(buildPayload())
        await callBulkDownloadApi()
      } catch (error) {
        console.error('Error downloading file:', error)
      }
    }

  return (
<ButtonDiv>
  <Button.Primary
      height={'38px'} 
      text={'Download Resume'} 
      width={'100%'}
      onClick={callBulkDownloadApi}
      disabled={isDownloading}
    />
  {/* {getDefaultResume() ? (
    <Button.Primary
      height={'38px'} 
      text={'Download Resume'} 
      width={'100%'}
      onClick={handleDownloadClick}
    />
  ) : (
    <PDFDownloadLink
      document={<NewResumeTemplate data={formattedData} />}
      fileName={`${formattedData?.student?.fullName || 'Resume'}.pdf`}
      onClick={() => callBulkDownloadApi()}
    >
      {({ loading, error }) => (
        <Button.Primary
          height={'38px'}
          text={loading ? 'Loading...' : 'Download Resume'}
          width={'100%'}
          disabled={loading}
          // onClick={handleStudentResumeDownload}
        />
      )}
    </PDFDownloadLink>
  )} */}
</ButtonDiv>
  )
}

export default StudentResumeDetailsAction
